import { render } from "./Version.vue?vue&type=template&id=64a04cab&scoped=true"
import script from "./Version.vue?vue&type=script&lang=js"
export * from "./Version.vue?vue&type=script&lang=js"

import "./Version.scss?vue&type=style&index=0&id=64a04cab&lang=scss&scoped=true&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64a04cab"]])

export default __exports__